import React from "react";
import styles from "./MFilter.module.css";
import { IconCaretDownFilled, IconCaretUpFilled } from "@tabler/icons-react";

export interface MFilterProps {
  text: string;
  selected?: boolean;
  rightIcon?: boolean | React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  variant?: 'default' | 'sm';
}

export const MFilter: React.FC<MFilterProps> = ({
  text,
  selected = false,
  rightIcon = true,
  onClick,
  className = "",
  disabled = false,
  variant = 'default',
}) => {
  return (
    <div
      className={[
        styles.mfilter,
        variant === 'sm' ? styles.sm : '',
        selected ? styles.selected : "",
        className
      ].filter(Boolean).join(" ")}
      tabIndex={0}
      role="button"
      aria-disabled={disabled}
      onClick={disabled ? undefined : onClick}
      style={{ userSelect: "none", pointerEvents: disabled ? "none" : undefined }}
    >
      <span className={styles.mfilter__label}>{text}</span>
      {rightIcon !== false && (
        <span className={styles.mfilter__rightIcon}>
          {rightIcon === true
            ? selected
              ? <IconCaretUpFilled size={18} />
              : <IconCaretDownFilled size={18} />
            : rightIcon}
        </span>
      )}
    </div>
  );
};

export default MFilter;
